import { render, staticRenderFns } from "./TeachingEditDialog.vue?vue&type=template&id=75a5db68"
import script from "./TeachingEditDialog.vue?vue&type=script&lang=js"
export * from "./TeachingEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports